'use strict';

angular.module('theme').factory('ArticleService', function ($q, $http) {

	var service = {

		getArticleTypes: function () {
			return $http({
				url: '/backapi/articletypes',
				cache: true
			}).then(function (response) {
				// Remove 7, 8 portions from prices array for now
				/*
				_.forEach(response.data.types, function (type) {
					// Don't filter out Special's prices
					if (type.type !== 'Special') {
						type.prices = _.filter(type.prices, function (p) { return p.number < 7; });
					}
				});
				*/

				return response.data.types;
			});
		},

		getArticles: function () {
			return $http({
				url: '/backapi/articles',
				cache: false
			}).then(function (response) {
				return response.data.items;
			});
		},

		getArticlesByProduct: function (productId) {
			return service.getArticles().then(function (articles) {
				return _.filter(articles, {type: productId});
			});
		},

		getArticle: function (articleId) {
			return service.getArticles().then(function (articles) {
				return _.find(articles, {id: articleId});
			});
		},

		getProduct: function (productId) {
			return service.getArticleTypes().then(function (articles) {
				var product = _.find(articles, {'type': productId});

				if (!product) {
					throw Error('No product with ' + productId + ' exists');
				}

				return product;
			});
		},

		getProductPrice: function (productId, servings) {
			return service.getProduct(productId).then(function (product) {
				var productPrice = _.find(product.prices, {number: servings});
				if (!productPrice) {
					return 0;
				}
				return productPrice.amount;
			});
		},

		getSupplementPrice: function (productId, supplementId, amount) {
			return service.getProduct(productId).then(function (product) {
				var supplement = product.supplements[supplementId];
				if (!supplement) {
					return 0;
				}
				return supplement * (amount || 1);
			});
		}

	};

	return service;
});
